/**
 * LOCALIZED-TEXT.UTILS
 * Text of a project written in several languages : the language of the participant, else the reference language of the project
 * (its first language : French comes first when the project has it), else French, else English, else any text written
 * (so that nothing is displayed empty when a text exists in a language)
 */

export function getLocalizedText(field: { [language: string]: string } | null | undefined, language: string, languages: string[] = []): string {
  if (!field) return ""
  if (field[language]) return field[language]
  const reference = [languages[0], "fr", "en"].find((lang) => lang && field[lang])
  if (reference) return field[reference]
  return (Object.values(field).find((value) => value) as string) ?? ""
}
